import { defineMessages } from 'react-intl';

const messages: {
	createPromptLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rewriteTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	createPromptLabel: {
		id: 'ai-mate.conversation-assistant.store-human.content-container.createPromptLabel',
		defaultMessage: 'Save prompt',
		description: 'Label for the save prompt button that appears on hover over user messages',
	},
	rewriteTooltip: {
		id: 'ai-mate.conversation-assistant.store-human.content-container.rewriteTooltip',
		defaultMessage: 'Re-write',
		description: 'Tooltip for the edit pencil shown on the most recent user message',
	},
});

export default messages;
